import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'

export const TemplateEnterpriseContactSchema = buildEntrySchemaFor('templateEnterpriseContactForm', {
  fields: z.object({
    body: RichTextSchema.optional(),
    headline: z.string(),
    label: z.string().optional(),
  }),
})

export type TemplateEnterpriseContactForm = z.infer<typeof TemplateEnterpriseContactSchema>
